// Radiogroup
// eg. Gender
// 

JLM.MD.Radiogroup = function( fieldset ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	let options;
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.value = null;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		options = $('.radiogroup li', fieldset);
		options.each(function() {
			// References
			let option = $(this),
				input = $('input[type="radio"]', option);
			
			// Settings
			let value = input.val();
			
			// Value
			if ( option.hasClass('selected') ) {
				INSTANCE.value = value;
			}
			
			// Events
			input.on('change', function() {
				selectOption( option, value );
			});
		});
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Select an option
	// 
	function selectOption( option, value ) {
		options.removeClass('selected');
		option.addClass('selected');
		INSTANCE.value = value;
		INSTANCE.dispatchEvent('change', [ INSTANCE.value ]);
	}
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};